import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import _classCallCheck from "reshow-runtime/es/helpers/classCallCheck";
import _createClass from "reshow-runtime/es/helpers/createClass";
import _assertThisInitialized from "reshow-runtime/es/helpers/assertThisInitialized";
import _possibleConstructorReturn from "reshow-runtime/es/helpers/possibleConstructorReturn";
import _getPrototypeOf from "reshow-runtime/es/helpers/getPrototypeOf";
import _inherits from "reshow-runtime/es/helpers/inherits";
import _defineProperty from "reshow-runtime/es/helpers/defineProperty";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Children, PureComponent } from "react";
import callfunc from "call-func";
import Change from "../organisms/Change";

var Replace = /*#__PURE__*/function (_PureComponent) {
  _inherits(Replace, _PureComponent);

  var _super = _createSuper(Replace);

  function Replace() {
    var _this;

    _classCallCheck(this, Replace);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      no: 0,
      childs: {}
    });

    _defineProperty(_assertThisInitialized(_this), "handleNext", function () {
      if (_this._time) {
        clearTimeout(_this._time);
      }

      var interval = _this.props.interval;

      _this.setState(function (_ref) {
        var no = _ref.no,
            childs = _ref.childs;
        no++;

        if (no >= childs.length) {
          no = 0;
        }

        return {
          no: no
        };
      });

      _this._time = setTimeout(_this.handleNext, interval);
    });

    return _this;
  }

  _createClass(Replace, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._time) {
        clearTimeout(this._time);
      }

      var interval = this.props.interval;
      this._time = setTimeout(this.handleNext, interval);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._time);
      this._time = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          interval = _this$props.interval,
          props = _objectWithoutProperties(_this$props, ["interval"]);

      var _this$state = this.state,
          no = _this$state.no,
          childs = _this$state.childs;
      return /*#__PURE__*/React.createElement(Change, props, childs[no]);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var children = nextProps.children;

      if (children === prevState.prevChildren) {
        return null;
      }

      var childs = [];
      Children.map(children, function (c) {
        return c;
      }).forEach(function (child, key) {
        return childs[key] = child;
      });
      return {
        childs: childs,
        prevChildren: children
      };
    }
  }]);

  return Replace;
}(PureComponent);

_defineProperty(Replace, "defaultProps", {
  interval: 5000
});

export default Replace;